import { render, staticRenderFns } from "./companyInformation.vue?vue&type=template&id=03a180db&scoped=true&"
import script from "./companyInformation.vue?vue&type=script&lang=js&"
export * from "./companyInformation.vue?vue&type=script&lang=js&"
import style0 from "./companyInformation.vue?vue&type=style&index=0&id=03a180db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a180db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03a180db', component.options)
    } else {
      api.reload('03a180db', component.options)
    }
    module.hot.accept("./companyInformation.vue?vue&type=template&id=03a180db&scoped=true&", function () {
      api.rerender('03a180db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/companyInformation.vue"
export default component.exports